// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"00f77887","453":"75831760","553":"68decc51","977":"4240d726"}[chunkId] + ".chunk.js";
};